module.exports = __webpack_public_path__ + "img/pn.c4a2e49f.svg";